import { computed, type Ref } from 'vue'

import { useTopProductsRankingCompareStore } from '@/stores/topProductsRankingCompare'

import type { TopProductsRankingCompareEntry, TopProductsRankingEntry } from './types'

function toSnapshot(entry: TopProductsRankingEntry): TopProductsRankingCompareEntry {
  return {
    tool: entry.tool,
    toolTitle: entry.toolTitle ?? entry.tool,
    rank: entry.rank ?? null,
    rating: entry.rating ?? null,
    reviewCount: entry.reviewCount ?? null,
  }
}

export function useTopProductsRankingCompare(productSlug: Ref<string>) {
  const store = useTopProductsRankingCompareStore()

  const selection = computed(() => store.selections[productSlug.value] ?? [])
  const count = computed(() => selection.value.length)

  function isSelected(tool: string): boolean {
    return selection.value.some((selected) => selected.tool === tool)
  }

  function add(entry: TopProductsRankingEntry): boolean {
    return store.add(productSlug.value, toSnapshot(entry))
  }

  function remove(tool: string) {
    store.remove(productSlug.value, tool)
  }

  function refresh(visible: TopProductsRankingEntry[]) {
    store.refresh(productSlug.value, visible.map(toSnapshot))
  }

  return { selection, count, isSelected, add, remove, refresh }
}
